const coupon = {
  // 优惠券列表
  getCouponList: `/userApi/v1/GameCoupon/getCouponList`,
  // 优惠券历史记录
  getCouponHistory: `/userApi/v1/GameCoupon/getCouponHistory`,
  // 可使用的优惠券
  toUseCoupon: `/userApi/v1/GameCoupon/toUseCoupon`,
  // 优惠券配置（是否可给他人充值）
  getCouponConfig: `/userApi/v1/GameCoupon/getCouponConfig`,
  //  优惠券充值
  couponRecharge: `/userApi/v1/GameCoupon/coupon_recharge`
};

export default coupon;
